const BYTE_ARRAY_INTERVAL = 29;

export const constants = {
	BYTE_ARRAY_INTERVAL
};

export default constants;
